module.exports = __webpack_public_path__ + "img/1.02.thmb.b0ebee65.jpg";